<template>
  <div id="exhibition">
    <div v-if="dataTest.length > 0" id="fff">
        <vxe-table
                stripe
                highlight-hover-row
                border
                resizable
                size="mini"
                :data.sync="dataTest"
                :loading="parloading"
                ref="testTableass"
                :max-height="MaxHeight"
        >
          <template v-slot:empty>
            <span style="font-size: 12px; color: red;">No record found !</span>
          </template>
          <template>
            <template v-for="(item, index) in cols">
              <vxe-table-column
                      show-header-overflow
                      show-overflow
                      :width="item.proWidth == null ? '250' : item.proWidth"
                      :key="index"
              >
                <template v-slot:header="{ column }">
                  <span v-cloak> {{ item.title }}</span>
                </template>
                <template v-slot="{ row }">
                  <img
                          v-if="row[item.label].config.fieldType == 'Image'"
                          :src="row[item.label].value"
                          width="80"
                          height="30"
                  />
                  <div v-else>
                    <a-tooltip placement="topLeft">
                      <template slot="title">
                    <span v-cloak>{{
                        row[item.label].value == null
                            ? "-"
                            : row[item.label].value
                      }}</span>
                      </template>
                      <span
                              v-if="row[item.label].config.fieldType == 'POPUP'"
                              style="fontSize: 12px;cursor:pointer;text-decoration:underline;"
                      >{{ row[item.label].value }}</span
                      >
                      <span
                              v-else
                              style="fontSize: 12px;height: 30px;line-height: 30px;display: block;"
                              v-cloak>{{
                          row[item.label].value == null
                              ? "-"
                              : row[item.label].value
                        }}</span
                      >
                    </a-tooltip>
                  </div>
                </template>
              </vxe-table-column>
            </template>
          </template>
        </vxe-table>
    </div>
    <a-pagination
            :pageSizeOptions="pageSizeOptions"
            :showTotal="total => `${$t('generic.totalOf')} ${pagingTotal} ${$t('generic.Records')}`"
            size="small"
            :total="pagingTotal"
            v-model="currentVal"
            :pageSize.sync="pagingSize"
            @change="tableChangePage"
            @showSizeChange="onShowSizeChange"
            showSizeChanger

    />
  </div>
</template>
<script>
    import ajax from "../../api/ajax";
    import cookie from '../../api/cookie';    
    import api from "../../api/url";
    import tableComs from "../com/tableComs.vue";
    export default {
        components:{
            tableComs,
        },
        data () {
            return {
                pageSizeOptions:['10', '20', '30', '40','100','500','1000'],
                pagingTotal: 50,
                currentVal: 1,
                pagingSize: Number.parseInt(sessionStorage.getItem('pageSize') || '30'),
                tableGmcuid: '',
                scroll: '',
                dataTest: [],
                cols: [],
                MaxHeight: 0,
                parloading: true
            }
        },
//        created(){
//            this.MaxHeight = document.body.clientHeight - 160;
//            this.init()
//        },
        mounted(){
            this.MaxHeight = document.body.clientHeight - 160;
            this.init()
            window.addEventListener('scroll',this.handleScroll,true)
        },
        methods: {
            handleScroll(e){
                this.$nextTick(()=>{
                    console.log(this.$refs.testTableass);
                })
//                if(e.target.scrollTop > 400){
//                    this.parloading = true
//                    let hh = this.dd.slice(51,100)
//                    this.dataTest =  this.dataTest.concat(hh)
//                    setTimeout(()=>{
//                        this.parloading = false
//                    },1000)
//                }
            },
            init(){
                let tt = {
                    menu: 'LOC',
                    userUid: 20,
                    functionUid: 5,
                    language: 2,
                    pageNum: 1,
                    pageSize: 10,
                }
                this.parloading = true
                ajax.get('/generic/impl', tt).then(res=>{
                    this.parloading = false
                    this.tableGmcuid = res.data.gmcUid;
                    this.dataTest= res.data.tableList.data
                    this.cols = res.data.tableList.columns
                })
            },
            initRenderFn(templateName){
                this.parloading = true;
                let params = {
                    functionUid: 5,
                    gmcUid: this.tableGmcuid,
                    language:2,
                    userUid: 20,
                    paging: {
                        pageNum: this.currentVal,
                        pageSize: this.pagingSize
                    }
                }
                ajax.post(api.SKUS, params).then(res=>{
                    this.parloading = false
                    let tt = res.data.tableList.data
                    this.dd = res.data.tableList.data


                    let cc = tt.slice(0, 50)
                    this.dataTest= cc
                    this.cols = res.data.tableList.columns

                })
            },
            tableChangePage(current){
                this.currentVal = current;
                this.initRenderFn();
            },
            onShowSizeChange(current, pageSize) {
                this.currentVal = current;
                this.pagingSize = pageSize;
                this.initRenderFn();
            },
        }
    }
</script>
<style lang="less">

</style>
